import React, { Component } from 'react';
import moment from 'moment-with-locales-es6';
import RadioButton from './RadioButton';
import TextInputLabel from './TextInputLabel';
import { getText, getParamByName } from '../config';

class FormFields extends Component {
    constructor(props) {
        super(props);
        this.selectDestination = this.selectDestination.bind(this);
        this.selectOrigin = this.selectOrigin.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
        this.openOutbound = this.openOutbound.bind(this);
        this.openInbound = this.openInbound.bind(this);
        this.closeDates = this.closeDates.bind(this);
        this.getPassengersString = this.getPassengersString.bind(this);

        this.state = {
            editOrigin: false,
            editDestination: false
        }
    }

    selectDestination() {
        this.props.openMenu('destinations');

        this.setState({
            editDestination: true
        })
    }

    selectOrigin() {
        this.props.openMenu('origins');

        this.setState({
            editOrigin: true
        })
    }

    openOutbound() {
        this.props.showDates('outbound');
    }

    openInbound() {
        this.props.showDates('inbound');
    }

    closeHandler() {
        this.props.openMenu(false);
        this.props.clearDestinationInput()
    }

    closeDates() {
        this.props.showDates(false)
    }

    getPassengersString() {
        let passengersString = "";
        let counts = [0,0,0,0];

        if(this.props.searchType === 'flight') {
            counts[0] =+ this.props.passengers.adult;
            counts[1] =+ this.props.passengers.child;
            counts[2] =+ this.props.passengers.baby;
            counts[3] =+ this.props.passengers.senior;
        } else {
            this.props.rooms.map((room) => {
                counts[0] = counts[0] + room.adult;
                counts[1] = counts[1] + room.child;
                counts[2] = counts[2] + room.baby;
                counts[3] = counts[3] + room.senior;
            })
        }

        if (counts[0] > 0) passengersString = passengersString + "<span>" + counts[0] + " " + getText('adult') + "</span>";
        if (counts[1] > 0) passengersString = passengersString + "<span>" + counts[1] + " " + getText('child') + "</span>";
        if (counts[2] > 0) passengersString = passengersString + "<span>" + counts[2] + " " + getText('baby') + "</span>";
        if (counts[3] > 0) passengersString = passengersString + "<span>" + counts[3] + " " + getText('senior') + "</span>";
        return passengersString;
    }

    render() {
        let passengersString = this.getPassengersString();

        return (
            <div className="form-fields">
                {this.props.searchType === 'flight' && <div className="form-field-row">
                    <div className="form-field-cell">
                        <RadioButton
                            type="radio"
                            shape="circle"
                            name="direction"
                            selected={this.props.direction === 'roundtrip'}
                            onChange={this.props.onDirectionChange}
                            value="roundtrip"
                            text={getText('roundtrip')} />
                    </div>
                    <div className="form-field-cell">
                        <RadioButton
                            type="radio"
                            shape="circle"
                            name="direction"
                            selected={this.props.direction !== 'roundtrip'}
                            onChange={this.props.onDirectionChange}
                            value="oneway"
                            text={getText('oneway')} />
                    </div>
                </div>}
                <div className="form-field-row">
                     <TextInputLabel
                        error={this.props.errors.origins}
                        clickHandler={this.selectOrigin}
                        closeHandler={this.closeHandler}
                        icon={this.props.imgPath + "flight-blue"}
                        text={this.props.origin || getText('originText' + (getParamByName('outbound') || 'TLV'))}
                        value={this.props.originInput}
                        onDestinationInput={this.props.onOriginInput}
                        isEdit={this.props.editOrigin}
                        placeholder={getText('originFlightPlaceholder')} />
                </div>
                <div className="form-field-row">
                    <TextInputLabel
                        error={this.props.errors.destinations}
                        clickHandler={this.selectDestination}
                        closeHandler={this.closeHandler}
                        icon={this.props.imgPath + "landing"}
                        text={this.props.destination || getText('landingAt')}
                        value={this.props.destinationInput}
                        onDestinationInput={this.props.searchType === 'flight' ? this.props.onDestinationInput : this.props.onDestinationInputHotel}
                        isEdit={this.props.editDestination}
                        placeholder={getText('destinationFlightPlaceholder')} />
                </div>
                <div className="form-field-row">
                    <TextInputLabel
                        error={this.props.errors.outbound}
                        closeHandler={this.closeDates}
                        clickHandler={this.openOutbound}
                        icon={this.props.imgPath + "calendar"}
                        text={this.props.outboundDate ? moment(this.props.outboundDate).format('DD/MM/YYYY') : getText('outboundDate')}
                        subText={this.props.outboundDate ? getText('outboundDate') : null} />
                    {this.props.direction === 'roundtrip' && <TextInputLabel
                        error={this.props.errors.inbound}
                        closeHandler={this.closeDates}
                        clickHandler={this.openInbound}
                        text={this.props.inboundDate ? moment(this.props.inboundDate).format('DD/MM/YYYY') : getText('inboundDate')}
                        subText={this.props.inboundDate ? getText('inboundDate') : null}
                        margin={true} />}
                </div>
                <div className="form-field-row">
                    <TextInputLabel
                        error={this.props.errors.passengers}
                        icon={this.props.imgPath + "passenger"}
                        clickHandler={this.props.showPassengers}
                        asHtml={passengersString.length > 0}
                        text={passengersString.length > 0 ? passengersString : getText('passengersCount')} />
                </div>
                <div className="form-field-row">
                    <RadioButton
                        type="checkbox"
                        shape="square"
                        name="direct"
                        text={getText('directFlightsOnly')}
                        value={true}
                        onChange={this.props.onDirectChange}
                        selected={this.props.direct}
                        full={true} />
                </div>
                <div className="form-field-row big">
                    <button className="search-button" onClick={this.props.sendForm}>
                        {this.props.searchType === 'flight' ? getText('searchButtonFlights') : getText('searchButtonPackages')}
                    </button>
                </div>
            </div>
        );
    }
}

FormFields.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default FormFields;



// WEBPACK FOOTER //
// ./src/components/FormFields.js